import React from "react";
import Section from "../components/Section";
import { EXPERIENCE_DETAILS } from "./constants";



export default function Experience() {
  return (
    <Section id="experience" title="Experience">
      {EXPERIENCE_DETAILS.map((experience, index) => (
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5" key={index}>
          <div className="flex-grow-1">
            <h3 className="mb-0">{experience.title}</h3>
            <div className="subheading mb-3">{experience.company}</div>
            <p>
              <strong>Roles/Responsibilities</strong><br />
              <ul>
                {experience.responsibilities.map((responsibility, idx) => (
                  <li key={idx}>{responsibility}</li>
                ))}
              </ul>
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="text-primary">{experience.duration}</span>
          </div>
        </div>
      ))}
    </Section>
  );
}
